// this might not be needed anymore..
// const { htmlToText } = require('html-to-text');
import isString from 'lodash/isString';
import { ALL_CUSTOM_HTML_TAGS } from './rich-text-box.const';

import { b64EncodeUnicode, b64DecodeUnicode } from './DataChip/base64-unicode-utils';

// import FormatConversionService from './format-conversion-service';

// const htmlToTextConf = { preserveNewlines: true, wordwrap: false, trimEmptyLines: false, whitespaceCharacters: '' };
// const brRegex = /<br\s*[/]?>/gi;

/* Private */

// const isPlainText = (format) => ![TEXT_BOX_FORMAT_TYPES.MARKDOWN, TEXT_BOX_FORMAT_TYPES.HTML].includes(format);

const hasOpeningAndClosingParagraph = (v) => v.indexOf('<p>') === 0 && v.slice(-4) === '</p>';

function containsCustomHtmlTags(str) {
	return ALL_CUSTOM_HTML_TAGS.reduce((result, htmlTag) => str.includes(htmlTag) || result, false);
}

function oneChipToCurleyBraces(prefix, suffix, htmlTag) {
	return (strWithOneChip) => {
		// Assumption: no nested chips
		if (!strWithOneChip.includes(`</${htmlTag}>`)) {
			return strWithOneChip;
		}
		const [chipContent, restOfTheString] = strWithOneChip.split(`"></${htmlTag}>`);
		const escapedContent = b64DecodeUnicode(chipContent);
		const contentContentObj = JSON.parse(escapedContent);
		return prefix + contentContentObj.content + suffix + restOfTheString;
	};
}

function replaceParagraphsWithSpans(html) {
	const arrayOfParagraps = html.split('<p ');
	if (arrayOfParagraps.length > 1) {
		const result = arrayOfParagraps
			.map((styleWithContent) => {
				if (styleWithContent !== '') {
					const [content, ...rest] = styleWithContent.split('</p>');
					const paragraphWithSpan = `<span ${content}</span></p>${rest.join('')}`;
					return paragraphWithSpan;
				}
				return styleWithContent;
			})
			.join('<p>');
		return result;
	}
	return html;
}
function replaceParagraphClosureWithBr(p, br) {
	const [pContent, contentNotContaniedInParagraph] = p.split('</p>');
	return contentNotContaniedInParagraph === '' ? pContent : [pContent, contentNotContaniedInParagraph].join(br) + br;
}
function replaceParagraphsWithLineBreaks(html, br) {
	const result = html
		.split('</p><p>')
		.join(br)
		.split('<p>')
		.slice(1) // remove first string as it's always empty which signifies nothing relating to Line Breaks
		.map((p) => replaceParagraphClosureWithBr(p, br))
		.join('');
	return result;
}

const testFunctions = {
	replaceParagraphsWithSpans,
};

/* Public */

function filterUndelimitedCharacters(prefix, suffix, taggedData) {
	const result = taggedData
		.split(prefix)
		.map((taggedDataAdnSuffixStr) => {
			if (taggedDataAdnSuffixStr === '') {
				return;
			}
			const [tagContent, ...rest] = taggedDataAdnSuffixStr.split(suffix);
			console.log('rest is filterred out: ', rest);
			return tagContent + suffix;
		})
		.join(prefix);
	return result;
}
function getLastDelimitedContent(prefix, suffix, taggedData) {
	const tagPrefixesArray = taggedData.split(prefix);
	const lastTagPrefix = tagPrefixesArray.pop();
	const lastTagContent = lastTagPrefix.split(suffix)[0];
	return lastTagContent === '' ? lastTagContent : prefix + lastTagContent + suffix;
}

function forEachDelimittedContent(prefix, suffix, content, func) {
	content.split(prefix).forEach((str) => {
		const [first, second] = str.split(suffix);
		if (!!first && second !== undefined) {
			return func(first);
		}
	});
}

function mapUnlessDelimittedContent(prefix, suffix, content, mapFunc) {
	const [first, ...rest] = content.split(prefix);
	const mappedRest = rest
		.map((str) => {
			const strArr = str.split(suffix);

			if (strArr.length > 1) {
				const firstStr = strArr.shift();
				return firstStr + suffix + strArr.map(mapFunc).join(suffix);
			} else {
				return `${strArr.join(suffix)}`;
			}
		})
		.join(prefix);

	return mappedRest.length > 1 ? mapFunc(first) + prefix + mappedRest : mapFunc(first);
}

function mapAllLines(content, mapFunc) {
	if (!isString(content)) {
		return content;
	}
	try {
		const builtContent = content.split('<p>').map((str) => {
			const [first, ...rest] = str.split('</p>');
			if (!!first && rest.length > 0) {
				return [mapFunc(first), ...rest].join('</p>');
			} else {
				return [first, ...rest].join('</p>');
			}
		});
		return builtContent.join('<p>');
	} catch (err) {
		console.error(err);
		return content;
	}
}

function mapAllDelimited(prefix, suffix, content, mapFunc) {
	if (!isString(content)) {
		return content;
	}
	const builtContent = content.split(prefix).map((str) => {
		const strArr = str.split(suffix);
		if (strArr.length > 1) {
			const firstStr = strArr.shift();
			let mappedValue = mapFunc(firstStr);
			mappedValue = [null, undefined].includes(mappedValue) ? '' : mappedValue;
			return mappedValue + strArr.join(suffix); // notice: there is implicit coercion here:   null ---> 'null'
		} else {
			return `${strArr.join('')}`;
		}
	});
	return builtContent.join('');
}

function tokenizeHtmlAttributesAndRun(htmlAttributes, content, funcToPerform) {
	const ATTRS_TOKEN = 'ply-attribute-token';
	const ATTR_SUFFIX = '"';
	const tempArrObject = {};
	if (!isString(content)) {
		return content;
	}
	let builtContent = content;
	htmlAttributes.forEach((attribute) => {
		tempArrObject[attribute] = [];
		builtContent = builtContent.split(`${attribute}="`).map((str, index) => {
			if (index > 0) {
				const strArr = str.split(ATTR_SUFFIX);
				if (strArr.length > 1) {
					const firstStr = strArr.shift();
					tempArrObject[attribute].push(firstStr);
					return `${ATTRS_TOKEN}---${attribute}` + strArr.join(ATTR_SUFFIX);
				} else {
					return `${strArr.join('')}`;
				}
			}
			return str;
		});
		builtContent = builtContent.join('');
	});

	const tokenized = builtContent;
	let newString = funcToPerform(tokenized);

	Object.keys(tempArrObject).forEach((attribute) => {
		const tempArr = tempArrObject[attribute];

		const arrayToInterleave = newString.split(`${ATTRS_TOKEN}---${attribute}`);
		const resultArr = [];
		for (let i = 0; i < arrayToInterleave.length; i++) {
			resultArr.push(arrayToInterleave[i]);
			if (tempArr[i]) {
				const prefix = `${attribute}="`;
				resultArr.push(prefix + tempArr[i] + ATTR_SUFFIX);
			}
		}
		newString = resultArr.join('');
	});

	return newString;
}

function tokenizeAndRun(prefix, suffix, content, funcToPerform) {
	const TOKEN = '|||||PLY||||';
	const tempArr = [];
	if (!isString(content)) {
		return content;
	}
	const builtContent = content.split(prefix).map((str) => {
		const strArr = str.split(suffix);
		if (strArr.length > 1) {
			const firstStr = strArr.shift();
			tempArr.push(firstStr);
			return TOKEN + strArr.join(suffix);
		} else {
			return `${strArr.join('')}`;
		}
	});
	const tokenized = builtContent.join('');
	const newString = funcToPerform(tokenized);
	const arrayToInterleave = newString.split(TOKEN);
	const resultArr = [];
	for (let i = 0; i < arrayToInterleave.length; i++) {
		resultArr.push(arrayToInterleave[i]);
		if (tempArr[i]) {
			resultArr.push(prefix + tempArr[i] + suffix);
		}
	}
	return resultArr.join('');
}

function replaceAllDelimitedDataToTipTapFormat(prefix, suffix, htmlTag, content, getContent) {
	content = content?.toString() || '';
	const isContentInsetedDataFromPreviousSteps = content.includes(prefix) && content.includes(suffix);
	if (!isContentInsetedDataFromPreviousSteps) {
		return content;
	}
	const builtContent = content.split(prefix).map((str) => {
		const strArr = str.split(suffix);
		if (strArr.length > 1) {
			if (containsCustomHtmlTags(strArr[0])) {
				// if the prefix/suffix are a part of the custom content
				return strArr.join(suffix);
			}
			const firstStr = strArr.shift();
			const content = getContent(firstStr);
			const encodedContent = b64EncodeUnicode(JSON.stringify(content)); // Encode with base64
			return `<${htmlTag} content="${encodedContent}"></${htmlTag}>${strArr.join(suffix)}`;
		} else {
			return `${strArr.join('')}`;
		}
	});
	return builtContent.join('');
}

function htmlTagsToCustomDelimiters(prefix, suffix, htmlTag, html) {
	const htmlSplitByPrefixesOfTags = html.split(`<${htmlTag} content="`);
	return htmlSplitByPrefixesOfTags.map(oneChipToCurleyBraces(prefix, suffix, htmlTag)).join('');
}

function removeEnclosingParagraphTags(value) {
	value = String(value); // all those indexOf requires String...
	return hasOpeningAndClosingParagraph(value) ? value.slice(3, -4) : value;
}

const ParsingService = {
	...testFunctions,
	replaceParagraphsWithLineBreaks,
	filterUndelimitedCharacters,
	getLastDelimitedContent,
	forEachDelimittedContent,
	mapUnlessDelimittedContent,
	mapAllLines,
	mapAllDelimited,
	replaceAllDelimitedDataToTipTapFormat,
	htmlTagsToCustomDelimiters,
	removeEnclosingParagraphTags,
	tokenizeAndRun,
	tokenizeHtmlAttributesAndRun,
};

export default ParsingService;
